/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React, { useState, useRef, useEffect } from 'react';

const EmployerFilterDropdown = ({
  value,
  onChange,
  options = [],
  className = '',
  showCounts = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const shouldShowCounts = showCounts && options.some(
    (option) => option.count !== undefined && option.count !== null
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const selected = options.find((option) => option.value === value) || options[0];

  if (!selected) {
    return null;
  }

  return (
    <div className={`employer-filter-dropdown ${className}`.trim()} ref={containerRef}>
      <button
        type="button"
        className={`employer-filter-dropdown-trigger btn-custom-size${isOpen ? ' is-open' : ''}`}
        onClick={() => setIsOpen((open) => !open)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className="employer-filter-dropdown-trigger-text">
          <span className="employer-filter-dropdown-label">{selected.label}</span>
          {shouldShowCounts && selected.count !== undefined && selected.count !== null && (
            <span className="employer-filter-dropdown-count">({selected.count})</span>
          )}
        </span>
        <i
          className={`fas fa-chevron-down employer-filter-dropdown-chevron${isOpen ? ' is-open' : ''}`}
          aria-hidden="true"
        />
      </button>

      {isOpen && (
        <ul className="employer-filter-dropdown-menu" role="listbox" aria-label="Filter options">
          {options.map((option) => {
            const isSelected = value === option.value;
            return (
              <li key={option.value} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={isSelected}
                  className={`employer-filter-dropdown-item btn-custom-size${isSelected ? ' is-selected' : ''}`}
                  onClick={() => {
                    onChange(option.value);
                    setIsOpen(false);
                  }}
                >
                  <span className="employer-filter-dropdown-item-label">{option.label}</span>
                  {shouldShowCounts && option.count !== undefined && option.count !== null && (
                    <span className="employer-filter-dropdown-item-count">{option.count}</span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default EmployerFilterDropdown;
